export class HomeCarouselModel {
  imageUrlFilePath?: string;
  imageUrl?: string;
  title?: string;
  summary?: string;
  id?: string;
  updatedAt?: number;
  createdAt?: number;
  side?: string;
}
